import { createContext, useContext } from 'react';
import type { TourScreen } from './steps';

export type TourScope = TourScreen | 'all';

export type TourApi = {
  /** Start the full tour, or one screen's. */
  start: (scope: TourScope) => void;
  /** The tour screen the user is on, if any ("Tour this screen"). */
  screen: TourScreen | null;
};

export const TourContextValue = createContext<TourApi | null>(null);

/** The tour's controls, for the sidebar and the command palette (TourProvider). */
export const useTour = (): TourApi => {
  const value = useContext(TourContextValue);
  if (!value) throw new Error('useTour must be used inside <TourProvider>');
  return value;
};
